import {useRoute, useRouter} from "vue-router/composables";
import {watch} from "vue";
import {CURRENT_STEP_KEY} from "@/constants/localStorageKeys";

const IGNORED_ROUTES = [
  '/signup/phone_number_authorization'
]

export const useStepStore = () => {
  const route = useRoute()
  const router = useRouter()
  let beforeRoutePath = '';

  router.beforeEach((_to, from, next) => {
    beforeRoutePath = from.path
    next()
  })

  return {
    isSignupRoute() {
      return route.path.startsWith('/signup')
    },
    isIgnoredRoute() {
      return IGNORED_ROUTES.some((path) => route.path === path)
    },
    shouldNavigate() {
      return this.isSignupRoute() && !this.isIgnoredRoute()
    },
    watchStep() {
      watch([route], () => {
        if (!this.isSignupRoute()) return

        if (!beforeRoutePath.startsWith('/signup')) {
          this.restoreRoute().then(() => {
            this.storeStep(route.name)
          })
        } else {
          this.storeStep(route.name)
        }
      })
    },
    storeStep(routeName) {
      localStorage.setItem(CURRENT_STEP_KEY, routeName);
    },
    async restoreRoute() {
      const currentStep = localStorage.getItem(CURRENT_STEP_KEY);

      if (currentStep !== null && currentStep !== route.name) {
        await router.replace({ name: currentStep });
      }
    }
  }
}
